// Medidas compartidas por la lista de tareas (izquierda) y la línea de tiempo
// (derecha). Ambas mitades usan las mismas alturas fijas, así que las filas quedan
// alineadas por construcción y no por cálculo.
export const COL_WIDTH = 40;
export const ROW_HEIGHT = 44;
// Cabecera de dos niveles: mes arriba, día abajo.
export const HEADER_LEVEL_HEIGHT = 26;
export const HEADER_HEIGHT = HEADER_LEVEL_HEIGHT * 2;
// Ancho de la lista de tareas (columna fija a la izquierda).
export const LEFT_WIDTH = 480;
// Ancho mínimo de columna al "Ajustar a todo".
export const MIN_COL_WIDTH = 12;
